import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Box,
  ListSubheader,
} from "@mui/material";
import { DataType, Mapping } from "./editor";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/appStore";
import { useEffect, useState } from "react";

interface MappingSelectorProps {
  path: string;
  mapping: Mapping;
  onChange: (mapping: Mapping) => void;
}

export function MappingSelector({
  path,
  mapping,
  onChange
}: MappingSelectorProps) {
  const [showTypeSelector, setShowTypeSelector] = useState(!!mapping.option);

  const mappingOptionsPlatform = useSelector((state: RootState) => state.outputJson.tagsPlatform?.data?.data);
  const mappingOptionsExcel = useSelector((state: RootState) => state.outputJson.tagsExcel?.data?.data);

  useEffect(() => {
    setShowTypeSelector(!!mapping.option);
  }, [mapping.option]);

  const handleMappingChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    onChange({
      ...mapping,
      option: value === "none" ? "" : value,
      type: value === "none" ? "" : mapping.type,
    });
  };

  const handleTypeChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    onChange({
      ...mapping,
      type: value === "none" ? "" : (value as DataType),
    });
  };

  const options = mappingOptionsExcel;

  return (
    <Box display="flex" flexDirection="row" gap={1}>
      <FormControl size="small" fullWidth sx={{mt:1, mb:1, flex: 0.7}}>
        <InputLabel>Mapping</InputLabel>
        <Select
          value={mapping.option || "none"}
          label="Mapping"
          onChange={handleMappingChange}
        >
          <MenuItem value="none">No mapping</MenuItem>
          {options &&
            Object.keys(options).map((key) => [
              <ListSubheader key={key}>{key}</ListSubheader>,
              ...options[key].map((option: any) => (
                <MenuItem key={`${key}.${option}`} value={`${key}.${option}`}>
                  {`${key}.${option}`}
                </MenuItem>
              )),
            ])}
        </Select>
      </FormControl>

      {showTypeSelector && (
        <FormControl size="small" fullWidth sx={{mt:1, mb:1, flex: 0.3}}>
          <InputLabel>Type</InputLabel>
          <Select
            value={mapping.type || "none"}
            label="Type"
            onChange={handleTypeChange}
          >
            <MenuItem value="none">No type</MenuItem>
            <MenuItem value="int">int</MenuItem>
            <MenuItem value="number">number</MenuItem>
            <MenuItem value="string">string</MenuItem>
            <MenuItem value="array">array</MenuItem>
            <MenuItem value="object">object</MenuItem>
            <MenuItem value="bool">Boolean</MenuItem>
            <MenuItem value="timestamp">Timestamp</MenuItem>
          </Select>
        </FormControl>
      )}
    </Box>
  );
}
